import BetBuilderImpl from './bet-builder.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;
/**
 * Betslip bet builder.
 *
 * @class BetBuilder
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * BetBuilder prop types.
 *
 * @property {Mojito.Services.Betslip.types.Betslip} betslip - Betslip.
 * @property {Mojito.Services.Betslip.types.STAKE_GROUP_NAME} [stakeGroup] - Stake group.
 * @property {string} [currencyCode] - Currency code.
 * @property {Mojito.Services.Betslip.types.BETSLIP_STATUS} [betslipStatus] - Betslip status.
 * @property {boolean} [hasPendingBonus = false] - Set to true if some bonus requests are pending (so bonuses info will be inactive).
 * @property {boolean} [bankersActivated = false] - Flag to indicate if bankers mode is activated.
 * @property {boolean} [isStakeGroupPending = false] - Flag to indicate if stake group change is in progress.
 * @property {boolean} [hasPendingBankerBet = false] - Flag to indicate if banker bet set/unset is in progress.
 *
 * @memberof Mojito.Modules.BetslipView.BetBuilder
 */
const propTypes = {
    betslip: PropTypes.object.isRequired,
    stakeGroup: PropTypes.string,
    currencyCode: PropTypes.string,
    betslipStatus: PropTypes.string,
    hasPendingBonus: PropTypes.bool,
    bankersActivated: PropTypes.bool,
    isStakeGroupPending: PropTypes.bool,
    hasPendingBankerBet: PropTypes.bool,
};

const defaultProps = {
    stakeGroup: '',
    hasPendingBonus: false,
    bankersActivated: false,
    isStakeGroupPending: false,
    hasPendingBankerBet: false,
};

export default UIView('BetBuilder', BetBuilderImpl, propTypes, defaultProps);
